(() => {
  'use strict';

  const DRAWER_SELECTOR = '.nm-wishlist-drawer';
  const CONTROL_SELECTOR = [
    'button',
    'a[role="button"]',
    '[role="button"]',
    'input[type="button"]',
    'input[type="submit"]'
  ].join(',');

  const normalise = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  const getControlLabel = (element) => normalise([
    element.textContent,
    element.value,
    element.getAttribute('aria-label'),
    element.getAttribute('title'),
    element.id,
    element.className
  ].filter(Boolean).join(' '));

  const brandWishlistControls = (scope = document) => {
    const drawers = scope.matches?.(DRAWER_SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(DRAWER_SELECTOR) || []);

    drawers.forEach((drawer) => {
      drawer.querySelectorAll(CONTROL_SELECTOR).forEach((control) => {
        if (control.classList.contains('nm-modal-close-button')) return;

        const label = getControlLabel(control);
        const isAddToCart = /add\s*to\s*cart/.test(label) || /add[-_\s]*cart/.test(label);

        if (isAddToCart) {
          control.classList.add('cwh-wishlist-primary-cta');
        }
      });
    });
  };

  const start = () => {
    brandWishlistControls(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            brandWishlistControls(node);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
